import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_CITY_INPUT_TYPE = 'postermywall-city-input';

export const POSTERMYWALL_CITY_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_CITY_INPUT_TYPE,
  inputName: 'city',
  dataMarkerAttribute: 'data-is-pmw-form-address-input',
  displayName: 'Address',
  placeholder: 'Enter city',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-address-input') !== null && el.getAttribute('name') === 'city',
});
